// The input is normalised (trim + lowercase) so the same address always hashes the same.
export async function sha256Hex(input: string): Promise<string> {
	const normalized = input.trim().toLowerCase();
	const bytes = new TextEncoder().encode(normalized);
	const digest = await crypto.subtle.digest("SHA-256", bytes);

	return Array.from(new Uint8Array(digest))
		.map((byte) => byte.toString(16).padStart(2, "0"))
		.join("");
}
